import { OvhMailOffer } from '../mail_migration';
import { validateEnumTranslations } from '../../safety_checks';

export const TRANSLATE_KEY_OVH_MAIL_OFFER = 'OVH_MAIL_OFFER_';

export const OvhMailOfferTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_OVH_MAIL_OFFER}${OvhMailOffer.EXCHANGE}`]: 'Exchange',
    [`${TRANSLATE_KEY_OVH_MAIL_OFFER}${OvhMailOffer.EMAIL_PRO}`]: 'Email Pro',
  },
};

//DONT TOUCH below this line
validateEnumTranslations(OvhMailOffer, OvhMailOfferTranslation, TRANSLATE_KEY_OVH_MAIL_OFFER, true);
